export const TERMINAL_DEVICE_MANUFACTURERS = ["Elo Touch Solutions"];
